exports.getServerHost = () => {
    if (process.env.VUE_APP_ENV_MODE == "LOCAL") {
        // Local dev server URL
        return "http://localhost:8000";
    } else if (process.env.VUE_APP_ENV_MODE == "PROD") {
        // Deployed server URL
        return "https://purapuraserver.azurewebsites.net";
    } else {
        throw `Environment variable is incorrectly set.`;
    }
}